export default __webpack_public_path__ + "static/media/astra-usedcard.23ee44e9.svg";